import { render, staticRenderFns } from "./DropTemplates.vue?vue&type=template&id=cff6197c&scoped=true&"
import script from "./DropTemplates.vue?vue&type=script&lang=js&"
export * from "./DropTemplates.vue?vue&type=script&lang=js&"
import style0 from "./DropTemplates.vue?vue&type=style&index=0&id=cff6197c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff6197c",
  null
  
)

export default component.exports